import { GLTexture } from '../texture.js';
export class Operation {
    _gl: any;
    _width: number;
    _height: number;
    _program: string;
    _name: string;
    _active: boolean;
    _disable: boolean;
    _touch: boolean;
    _type: string | null;
    _texture: GLTexture | null;
    _pixels: Uint8Array | null;
    _selection: GLTexture | null;
    _selectionPixels: Uint8Array | null;

    constructor(gl: any, width: number, height: number, program: string, name: string) {
        var self = this;
        self._gl = gl;
        self._width = width;
        self._height = height;
        self._program = program;
        self._name = name;
        self._active = true;
        self._disable = false;
        self._touch = true;
        self._type = null;
        self._texture = null;
        self._pixels = null;
        self._selection = null;
        self._selectionPixels = null;
    }

    touch() {
        this._touch = true;
    }

    touched() {
        return this._touch;
    }

    untouch() {
        this._touch = false;
    }

    get disabled() {
        return this._disable;
    }

    set disable(value: boolean) {
        this._disable = value;
    }

    get activated() {
        return this._active;
    }

    set active(value: boolean) {
        var self = this;
        self._active = value;
        self._touch = true;
    }

    get texture() {
        var self = this;
        if (!self._texture) {
            self._texture = GLTexture.createTexture2d(self._gl, false);
            self._texture.bind();
            self._gl.texImage2D(self._gl.TEXTURE_2D, 0, self._gl.RGBA, self._width, self._height, 0, self._gl.RGBA, self._gl.UNSIGNED_BYTE, self._pixels);
            self._texture.unbind();
        }

        return self._texture;
    }

    get selection() {
        var self = this;
        if (!self._selection) {
            self._selection = GLTexture.createTexture2d(self._gl, false);
            self._selection.bind();
            self._gl.texImage2D(self._gl.TEXTURE_2D, 0, self._gl.RGBA, self._width, self._height, 0, self._gl.RGBA, self._gl.UNSIGNED_BYTE, self._selectionPixels);
            self._selection.unbind();
        }

        return self._selection;
    }

    get hasSelection() {
        var self = this;
        return !!self._selection || !!self._selectionPixels;
    }

    store() {
        var self = this;
        if (!self._texture) {
            self._texture = GLTexture.createTexture2d(self._gl, false);
        }
        self._texture.bind();
        self._gl.copyTexImage2D(self._gl.TEXTURE_2D, 0, self._gl.RGBA, 0, 0, self._width, self._height, 0);
        self._texture.unbind();
    }

    storeSelection(selection) {
        var self = this;
        if (!self._selection) {
            self._selection = GLTexture.createTexture2d(self._gl, false);
        }
        self._gl.viewport(0, 0, self._width, self._height);
        self._selection.bind();
        self._gl.bindFramebuffer(self._gl.FRAMEBUFFER, selection);
        self._gl.copyTexImage2D(self._gl.TEXTURE_2D, 0, self._gl.RGBA, 0, 0, self._width, self._height, 0);
        self._gl.bindFramebuffer(self._gl.FRAMEBUFFER, null);
        self._selection.unbind();
    }

    destroy() {
        var self = this;
        if (self._texture) {
            self._texture.bind();
            var framebuffer = self._gl.createFramebuffer();
            self._gl.bindFramebuffer(self._gl.FRAMEBUFFER, framebuffer);
            self._gl.framebufferTexture2D(self._gl.FRAMEBUFFER, self._gl.COLOR_ATTACHMENT0, self._gl.TEXTURE_2D, self._texture._texture, 0);
            self._pixels = new Uint8Array(self._width * self._height * 4);
            self._gl.readPixels(0, 0, self._width, self._height, self._gl.RGBA, self._gl.UNSIGNED_BYTE, self._pixels);
            self._gl.bindFramebuffer(self._gl.FRAMEBUFFER, null);
            self._gl.deleteFramebuffer(framebuffer);
            self._texture.unbind();
            self._gl.deleteTexture(self._texture._texture);
            self._texture = null;
        }

        if (self._selection) {
            self._selection.bind();
            var framebuffer = self._gl.createFramebuffer();
            self._gl.bindFramebuffer(self._gl.FRAMEBUFFER, framebuffer);
            self._gl.framebufferTexture2D(self._gl.FRAMEBUFFER, self._gl.COLOR_ATTACHMENT0, self._gl.TEXTURE_2D, self._selection._texture, 0);
            self._selectionPixels = new Uint8Array(self._width * self._height * 4);
            self._gl.readPixels(0, 0, self._width, self._height, self._gl.RGBA, self._gl.UNSIGNED_BYTE, self._selectionPixels);
            self._gl.bindFramebuffer(self._gl.FRAMEBUFFER, null);
            self._gl.deleteFramebuffer(framebuffer);
            self._selection.unbind();
            self._gl.deleteTexture(self._selection._texture);
            self._selection = null;
        }
    }

    get program() {
        return this._program;
    }

    get name() {
        return this._name;
    }

    get type() {
        return this._type;
    }

}